import Vue from 'vue'
import axios from 'axios'
import router from '@/router'
import qs from 'qs'
// import { getCookie,removeCookie } from '@/common/js/cookie'
// import { Message } from 'element-ui';

axios.defaults.timeout = 10000;
axios.defaults.withCredentials = true;

// export const CONFIG = {
// 	captchaCode: process.env.NODE_ENV === 'production' ? 'http://192.168.1.10:8285/anon/v1/graphCaptcha/get.do?' : 'http://192.168.1.10:8285/anon/v1/graphCaptcha/get.do?',
// 	upload: process.env.NODE_ENV === 'production' ? 'http://192.168.1.10:8285/anon/v1/common/upload.do?' : 'http://192.168.1.10:8285/anon/v1/common/upload.do?',
// 	addByImport: process.env.NODE_ENV === 'production' ? 'http://192.168.1.10:8285/admin/v1/productStock/addByImport.do' : 'http://192.168.1.10:8285/admin/v1/productStock/addByImport.do',
// }

const $http = new axios.create({
	baseURL : process.env.NODE_ENV === 'production' ? 'https://merchant.wishpay-global.com/' : 'http://192.168.1.10:7217/'
});

export function www (){
	return process.env.NODE_ENV === 'production' ? 'https://merchant.wishpay-global.com/' : 'http://192.168.1.10:7217/';
}

$http.interceptors.request.use(config => {
	return config
}, err => {
	return Message.info(err)
})


export function $axiosGet(url,params,header={}){
	return new Promise((resolve,reject) => {
		$http({
			methods :'get',
			url     : url,
			params  : params,
			headers : Object.assign({
				'X-Requested-With':'XMLHttpRequest'
			},header)
		}).then(res => {
			resolve(res)
		}).catch( err => {
			reject(err)
		})

	})
}

export function $axiosPost(url,data,header={}){
	return new Promise((resolve,reject) => {
		$http({
			method : 'post',
			url    : url,
			data   : qs.stringify(data),
			headers: Object.assign({
				'X-Requested-With':'XMLHttpRequest'
			},header)
		}).then(res => {
			resolve(res)
		}).catch(err => {
			reject(err)
		})
	})
}


export default $http



// WEBPACK FOOTER //
// ./src/assets/js/http.js